import React from 'react';
import { FormattedMessage } from 'react-intl';

const Text = props => <FormattedMessage {...props} />

export default Text;
